import { useForceUpdate } from './useForceUpdate';
import { useTimeoutUntil } from './useTimeoutUntil';

export function useTimeHasCome(timestampMs?: number | null): boolean | undefined {
  const now = Date.now();
  const timeHasCome = timestampMs ? now >= timestampMs : false;

  const update = useForceUpdate();
  useTimeoutUntil(update, timeHasCome || !timestampMs ? null : timestampMs);

  return timestampMs ? timeHasCome : undefined;
}
